export const initNpsSurvey = () => {
  const trustpilotReviewButton = document.getElementById("nps-trustpilot-review");

  if (!trustpilotReviewButton) {
    return;
  }

  // Record the "review on Trustpilot" badge when the user clicks through. The homepage widget does
  // this via #badges (see pages/badges.ts), but the NPS submitted page uses a standalone button, so
  // we fire the same endpoint here. Opening Trustpilot itself is handled by the go-to-url component.
  trustpilotReviewButton.addEventListener("click", () => {
    fetch("/website-api/badges/review_trustpilot/", {
      credentials: "same-origin",
      method: "post",
    }).catch(() => {
      // Best effort: navigation to Trustpilot must not depend on the badge call succeeding.
    });
  });
};
